// app tags
export const CLIENT_ID = 'coreWeb';

// auth0
export const AUTH0_DOMAIN = 'dev-rapanzd5.us.auth0.com';
export const AUTH0_CLIENT_ID = '04oi4Gs0iiDsrCxRdQIlLkPTzbVkCwkK';
export const AUTH0_AUDIENCE = 'https://api.emvest.ai';
